<template>
    <div class="myTable">
        <div class="searchNav">
            <el-button class="newAdd" type="primary" @click="showAddPermissionPage" icon="el-icon-plus" v-if="$can('auth-role:add')">新增角色</el-button>
            <span><span class="searchNameStyle">角色 ：</span><el-input v-model="searchInfo.role" clearable placeholder="请输入"></el-input></span>
            <el-button type="primary" icon="el-icon-search" @click="search" style="float: right; position: relative;left: -20px;" >搜索</el-button>
        </div>
        <div class="tableStyle">
            <el-table v-loading="loading" :data="tableData" style="width: 100%;" :row-class-name="tableRowClassName">
                <el-table-column
                        type="index"
                        width="50">
                </el-table-column>
                <el-table-column prop="role" label="角色" ></el-table-column>
                <el-table-column prop="description" label="描述" ></el-table-column>
                <el-table-column prop="createTime" label="创建时间"></el-table-column>
<!--                <el-table-column prop="modifyTime"  label="修改时间"></el-table-column>-->
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="250">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" v-if="$can('auth-role:edit')"   @click="editRole(scope.row)">编辑</el-button>
                        <span style="padding-left: 15px;">
                            <el-button type="text" size="small" v-if="$can('auth-role:remove') && scope.row.id >21"  @click="confirmRemove(scope.row.id)">删除</el-button>
                            <el-button type="text" size="small" v-else style="color: #ccc;" >删除</el-button>
                        </span>
                    </template>
                </el-table-column>
                <!-- 自定义空数据展示 -->
                <template slot="empty">
                    <div class="empty-container">
                        <el-empty :image-size="200"></el-empty>
                    </div>
                </template>
            </el-table>
            <el-pagination style="text-align: right;"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-size="searchInfo.pageSize"
                    :page-sizes="[10,20, 50, 100]"
                    layout="sizes, prev, pager, next ,total"
                    :total="total">
            </el-pagination>
        </div>
        <div>
            <el-dialog
              :title="dialogTitle"
              :closeOnClickModal="false"
                    :visible.sync="dialogVisible"
                    width="50%"
                    :before-close="handleClose"
                    center>
                <div class="addInfoStyle">
                    <div><span>角色：</span><el-input v-model="addInfo.role" placeholder="请输入" clearable></el-input>
                        <span>描述：</span><el-input  v-model="addInfo.description" placeholder="请输入" clearable></el-input>
                    </div>
                    <div v-for="level1 in permissions" :key="level1.id">
                        <div>{{ level1.description }}</div>
                        <div v-for="level2 in level1.permissionList" :key="level2.id">
                            <el-checkbox :label="level2.id"
                                         style="padding-left: 40px;"
                                         @change="() => handleCheckChange1(level2)"
                                         :value="level2Checked(level2)"
                                         :indeterminate="indeterminateStates[level2.id]">{{ level2.description }}</el-checkbox>
                            <div>
                                <el-checkbox v-for="level3 in level2.permissionList"
                                             class="permissionsStyle"
                                             :label="level3.id"
                                             :key="level3.id"
                                             v-model="checkedPermissions"
                                             @change="() => handleCheckChange(level2)">{{ level3.description }}</el-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="clear: both"></div>
                <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
    </div>
            </el-dialog>
        </div>
    </div>

</template>

<script>
    import {axios} from "../../config/axios";
    let currentTree; // 临时保存要移向的树
    export default {
        name: "white-list",
        data () {
            return {
                unOwnPermissions: [], // 未拥有的树权限数据
                ownPermissions:[],    // 已拥有的树权限数据
                havePermissions:[],
                defaultCheckedKeys:[],
                dialogTitle:'',
                interval:0, // 定时任务解决 将左侧选择的移到右侧 时可以出现 为空的情况
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                total:1,
                tableData: [],
                loading: false,
                dialogVisible: false,
                currentPage:1,
                roleList:'', // 得到角色
                addInfo:{
                    role:'',
                    description:'',
                    level1Menu:[],
                    level2Menu:[],
                    permissions:[]
                },
                searchInfo:{
                    role:'',
                    pageNumber:1,
                    pageSize:50,
                },
                permissions:[],
                checkedPermissions: [],
                indeterminateStates: {},
                level2States: {}  // 用来存储 level2 的勾选状态 半选中状态
            }
        },
        created: function () {
            this.getAllRole(); // 搜索框中使用
            this.pageInfo();
        },
        watch: {
            'searchInfo.role'(newVal,oldVal){
                if ("" == newVal){
                    this.pageInfo();
                }
            },
        },
        computed: {
            // 计算属性，用于更新 level2 的勾选状态
            level2Checked() {
                return (level2) => {
                    return level2.permissionList.every((level3) => this.checkedPermissions.includes(level3.id));
                };
            }
        },
        methods:{
            handleCheckChange(level2) {
                const allLevel3Ids = level2.permissionList.map(c => c.id);
                const allChecked = allLevel3Ids.every(id => this.checkedPermissions.includes(id));
                const anyChecked = allLevel3Ids.some(id => this.checkedPermissions.includes(id));

                if (allChecked) {
                    this.checkedPermissions = [...new Set([...this.checkedPermissions, ...allLevel3Ids])];
                    this.indeterminateStates[level2.id] = false;
                    this.level2States[level2.id] = true;  // 全选
                } else if (!anyChecked) {
                    this.checkedPermissions = this.checkedPermissions.filter(id => !allLevel3Ids.includes(id));
                    this.indeterminateStates[level2.id] = false;
                    this.level2States[level2.id] = false;  // 全不选
                } else {
                    this.indeterminateStates[level2.id] = true;
                    this.level2States[level2.id] = true;  // 半选状态，视为未全选
                }
            },
            handleCheckChange1(level2) {
                const childrenIds = level2.permissionList.map(child => child.id);
                const allChecked = childrenIds.every(id => this.checkedPermissions.includes(id));
                const anyChecked = childrenIds.some(id => this.checkedPermissions.includes(id));

                if (allChecked) {
                    this.checkedPermissions = this.checkedPermissions.filter(id => !childrenIds.includes(id));
                    this.indeterminateStates[level2.id] = false;
                    this.level2States[level2.id] = false;  // 取消全选
                } else {
                    this.checkedPermissions = [...new Set([...this.checkedPermissions, ...childrenIds])];
                    this.indeterminateStates[level2.id] = anyChecked && !allChecked;
                    this.level2States[level2.id] = true;  // 设置全选
                }
            },
            search(){
                this.pageInfo();
            },
            showAddPermissionPage(){
                this.dialogTitle = "新增角色";
                this.dialogVisible = true;
                this.addInfo.id = undefined;
                this.checkedPermissions = [];
            },
      //改为全局方法
            handleCurrentChange(val) {
                this.currentPage = val;
                this.searchInfo.pageNumber = val ;
                this.pageInfo();
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.currentPage = 0;
                this.searchInfo.pageSize = val ;
                this.pageInfo();
            },
            validate(){
                let flag = true;
                let msg  = "";
                return {code:flag,msg:msg}
            },
            save(){
                // 过滤到二级 数据
                const level2Value = [];
                for (const key in this.level2States) {
                    if (this.level2States[key] === true) {
                        level2Value.push(parseInt(key));
                    }
                }
                // 得到 一级菜单
                let level1DataArr = [];
                // 遍历得到
                for (let i = 0; i < this.permissions.length; i++) {
                    let level1Data = this.permissions[i].permissionList;
                    for (let i = 0; i < level1Data.length; i++) {
                        let level2Data = level1Data[i];
                        let parentId = level2Data.id
                        if (level2Value.indexOf(parentId)> -1 && level1DataArr.indexOf(parentId) == -1) {
                            level1DataArr.push(level2Data.parentId);
                        }
                    }
                }
                this.addInfo.level1Menu =  [...new Set(level1DataArr)];
                this.addInfo.level2Menu = level2Value;
                this.addInfo.permissions = this.checkedPermissions;
                let validateObj = this.validate();
                if (validateObj.code){
                    if (typeof (this.addInfo.id) === "undefined"){ // 新增
                        axios.post('/role',this.addInfo).then(result => {
                            this.dialogVisible = false;
                            if (result.code !== 200){
                                console.log(result);
                            }
                            this.pageInfo();
                            this.clearObj(this.addInfo); // 清空新增数据
                        }).catch(err => {
                            console.log(err);
                        });
                    } else { // 编辑
                        axios.put('/role',this.addInfo).then(result => {
                            this.dialogVisible = false;
                            if (result.code !== 200){
                                console.log(result);
                            }
                            this.pageInfo();
                            this.clearObj(this.addInfo); // 清空新增数据
                        }).catch(err => {
                            console.log(err);
                        });
                    }
                }else{
                    this.msg(validateObj.msg);
                }
            },
            editRole(obj){
                this.dialogTitle = "编辑角色";
                this.addInfo = JSON.parse(JSON.stringify(obj));

                this.dialogVisible = true; // 展现页面
                // 遍历所有权限去渲染 菜单选中状态
                this.getOwnPermissions(this.addInfo.id);
            },
            remove(id){
                axios.delete('/role',{data: {id:id}}).then(result => {
                    if (result.code !== 200){
                        console.log(result);
                    }
                    this.pageInfo();
                })
            },
            confirmRemove(obj){
                this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.remove(obj);
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            handleClose(done) {  // 弹出框点击右上角的 X 隐藏弹出框
                this.clearObj(this.addInfo); // 清空新增数据
                done();
            },
            getAllRole(){
                axios.get('/allMenuAndPermissions',{
                    params: {}
                }).then(result => {
                    if (result.code !== 200){
                        console.log(result);
                    }
                    this.permissions = result.data;
                }).catch(err => {
                    console.log(err);
                });

            },
            pageInfo(){
                if (this.loading)  return; // 防止重复提交
                this.loading=true;
                axios.get('/role',{
                    params: this.searchInfo
                }).then(result => {
                    this.loading=false;
                    if (result.code !== 200){
                        console.log(result);
                    }
                    let page = result.data;
                    this.total = page.total;
                    this.tableData = page.list;
                }).catch(err => {
                    console.log(err);
                    this.loading=false;
                });
            },
            getOwnPermissions(roleId){
                axios.get('/permissionByRoleId',{params:{roleId:roleId}}).then(result => {
                    if (result.code !== 200){
                        console.log(result);
                    }
                    this.checkedPermissions = result.data;
                    this.permissions.forEach(item=>{
                        let level2 = item.permissionList;
                        level2.forEach(obj=>{
                            this.handleCheckChange(obj);
                        })
                    })
                });
            },

        }
    }
</script>
<style lang="less" scoped>
    .addInfoStyle div{
        line-height: 2;
        .el-input{
            margin-right: 15px;
            width: 200px;
        }
    }
    .permissionsStyle{
        padding-left: 80px;
        font-size: 12px;
        color: #636569;
        font-weight: 400;
    }
</style>
